import { Button, useToast } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type { LdapUser } from 'brokertslib/src/dtos/User/LdapUser'
import { useGetLdapUser } from 'brokertslib/src/hooks/useOrganizationUnit'
import { Cloud } from '../../../icons'

export const LoadLdapUserButton = ({
  userName,
  onSubmit,
}: {
  userName: string
  onSubmit: (ldapUser: LdapUser) => void
}) => {
  const toast = useToast()
  const { mutateAsync: getLdapUser, isLoading } = useGetLdapUser()

  const loadFromLdap = async () => {
    await getLdapUser(userName)
      .then((result) => {
        toast({
          title: 'Údaje byly načteny z LDAP',
          status: 'success',
        })

        onSubmit(result.data)

        return result.data
      })
      .catch((e: AxiosError) => {
        if (e.response?.status === 404)
          return toast({
            title: 'Uživatel nebyl nalezen v LDAP',
            status: 'error',
          })

        toast({
          title: 'Uživatele nelze načíst z LDAP',
          description: `${e.response?.status}: ${e.response?.statusText}`,
          status: 'error',
        })

        return e.cause ?? new Error('Unknown error')
      })
  }

  return (
    <Button
      variant="outline"
      mt={6}
      onClick={loadFromLdap}
      isDisabled={!userName}
      isLoading={isLoading}
    >
      <Cloud color="secondary.500" />
      Načíst údaje z LDAP
    </Button>
  )
}
